import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketAddCoupon',
  props: {
    isCouponSubmitted: { required: true, type: Boolean },
    canAddCoupon: { required: true, type: Boolean },
    currentCouponCode: {
        required: false,
        validator: prop => typeof prop === 'string' || prop === null,
        default: '',
        type: String
    }
},
  emits: ["add"],
  setup(__props, { emit }: { emit: ({(e: 'add', couponCode: string)}), expose: any, slots: any, attrs: any }) {

const props = __props




const couponCode = ref<string>('');

function addCoupon(couponCode: string): void {
    const isCouponEmpty = !couponCode;
    if (isCouponEmpty) { return; }

    emit('add', couponCode);
}

const submittingCouponFailed = computed<boolean>(() => {
    return props.isCouponSubmitted && !props.currentCouponCode;
});


return { __sfc: true,props, emit, couponCode, addCoupon, submittingCouponFailed }
}

})